
import { DateObject } from '../reusables/date-object';
import { CampaignActivityTranslationService } from '../../../shared/translations/customer/campaign-activity-translations.service';

/**
 * Blueprint for the customer entity.
 */
export class CampaignActivity {
  public action: string;
  public campaignTitle: string;
  public timestamp: DateObject;
  public mailingId: string;
  public campaignUrl: string;
  public logDescription: string;

  public actions: Array<any> = [
    { value: 'mail_send', action: this.actionTranslations.i18nMailSend },
    { value: 'mail_click', action: this.actionTranslations.i18nLinkClick },
    { value: 'mail_bounce', action: this.actionTranslations.i18nMailBounce },
    { value: 'mail_open', action: this.actionTranslations.i18nMailOpen},
    { value: 'user_subscribe', action: this.actionTranslations.i18nUserSubscribe },
    { value: 'user_unsubscribe', action: this.actionTranslations.i18nUserUnsubscribe},
    { value: 'user_activated', action: this.actionTranslations.i18nUserActivated},
    { value: 'user_deactivated', action: this.actionTranslations.i18nUserDeactivated},
  ];

  constructor(customer: any, private actionTranslations: CampaignActivityTranslationService) {
    this.action = customer.action;
    this.campaignTitle = customer.campaignTitle;
    this.timestamp = new DateObject(customer.timestamp, 'dd.MM.yyyy HH:mm');
    this.mailingId = customer.mailingId;
    this.campaignUrl = customer.campaignUrl;
    this.logDescription = customer.logDescription;
  }

  public get translatedCampaignActivityAction(): string | string {
    if (this.action === 'log') {
      return this.logDescription;
    }

    const translatedAction = this.actions.find((action: any) => this.action === action.value);

    return translatedAction ? translatedAction.action : this.action;
  }
}
